import api from "./httpClient";
import { API_PATHS } from "./apiPaths";

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

const getRoleNamespace = (role = "teacher") => {
  if (role === "admin") return API_PATHS.admin;
  if (role === "teacher") return API_PATHS.teacher;
  return API_PATHS.student;
};

export const listAssessments = async ({ role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.get(ns.assessments());
  const payload = unwrap(response);
  return Array.isArray(payload) ? payload : [];
};

export const createAssessment = async (payload, { role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.post(ns.assessments(), payload);
  return unwrap(response);
};

export const updateAssessment = async (assessmentId, payload, { role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.put(ns.assessmentById(assessmentId), payload);
  return unwrap(response);
};

export const deleteAssessment = async (assessmentId, { role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.delete(ns.assessmentById(assessmentId));
  return unwrap(response);
};

export const publishAssessment = async (assessmentId, { role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.patch(ns.publishAssessment(assessmentId), {});
  return unwrap(response);
};

export const unpublishAssessment = async (assessmentId, { role = "teacher" } = {}) => {
  const ns = getRoleNamespace(role);
  const response = await api.patch(ns.unpublishAssessment(assessmentId), {});
  return unwrap(response);
};

export const startAssessmentAttempt = async (assessmentId) => {
  const response = await api.post(API_PATHS.student.startAssessment(assessmentId), {});
  return unwrap(response);
};

export const submitAssessmentAttempt = async (assessmentId, payload) => {
  const response = await api.post(API_PATHS.student.submitAssessment(assessmentId), payload);
  return unwrap(response);
};
